// 放图片的服务器
export let imgUrl="http://s1.event.kongquechao.com/";


